<template>
    <section v-if="hasPermissions(['Budgeting-Staffing-Variable Read', 'Budgeting-Staffing-Variable Write'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                Click Add Staffing Variable to create a new Variable item.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="staffing_variables.length && hasPermissions(['Budgeting-Staffing-Variable Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <span class="button__modal d-inline" v-if="hasPermissions(['Budgeting-Staffing-Variable Write'])">
                    <button class="modal__buttons__item w-auto mr-md-auto ml-sm-2 px-3 ml-md-2" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
                </span>
                <a class="modal__buttons__item w-auto px-3" :href="`/budgeting-staffing-scenario/update/${this.$route.params.id}`" v-html="'Back to Scenario'"/>
                <a class="modal__buttons__item w-auto px-3" :href="`/budgeting-staffing-scenario/${parent_id}`" v-html="'Edit Fixed Items'" v-if="hasPermissions(['Budgeting-Staffing-Fixed Read', 'Budgeting-Staffing-Fixed Write'])"/>
            </div>
            <div  v-if="hasPermissions(['Budgeting-Staffing-Variable Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="staffing_variables.length && hasPermissions(['Budgeting-Staffing-Variable Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <div class="table-responsive table-fix-head" style="max-height: 35rem;">
                            <table>
                                <thead>
                                    <tr>
                                        <th slot="header" scope="col">
                                            <span class="custom-control custom-checkbox">
                                                <input :id="`theadcheck`" v-model="select_all" type="checkbox" class="custom-control-input"/>
                                                <label :for="`theadcheck`" class="custom-control-label ml-2"/>
                                            </span>
                                        </th>
                                        <th scope="col" class="header-item">
                                            <span style="margin-left: 5px;" v-html="'Detail'"/>
                                        </th>
                                        <th scope="col" v-for="(val, i) in table_headers" :key="i" v-html="val.text" />
                                    </tr>
                                </thead>
                                <draggable v-model="staffing_variables" tag="tbody" @start="drag=true" @end="drag=false" @change="updateOrd()">
                                    <tr v-for="(val, i) in staffing_variables" :key="i">
                                        <td scope="col">
                                            <span class="custom-control custom-checkbox">
                                                <input :id="`checkAll${i}`" type="checkbox" class="custom-control-input" v-model="val.checked"/>
                                                <label :for="`checkAll${i}`" class="custom-control-label ml-2"/>
                                            </span>
                                        </td>
                                        <td scope="col">
                                            <a 
                                                class="bold-text"
                                                style="color: #039be5; text-decoration: none;"
                                                @click="modal_update(i)"
                                            >
                                                <span style="margin-left: 5px;">
                                                    <img :src="`/assets/img/svg/update_entry.svg`" style="width:15px;" alt="Update Entry Icon"/>
                                                </span>
                                            </a>
                                        </td>
                                        <!-- <th scope="row" v-html="i + 1"/> -->
                                        <td scope="row" v-for="(header, j) in table_headers" :key="j" v-html="val[header.value]" />
                                    </tr>
                                </draggable>
                            </table>
                        </div> 
                    </div>
                </div>
            </div>
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <DeletionMassiveModal
          @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Staffing Variable'"
            :parent_id="uncrypted_parent_id"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Staffing Variable Update'"
            :parent_id="uncrypted_parent_id"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />
        <WaitingModal/>
    </section>
</template>

<script>
import axios                from    'axios';
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import Resources            from    './resources'
import FormModal            from    './FormModal'
import UpdateModal          from    './UpdateModal'
import DeletionModal        from    '@/components/DeletionModal'
import DeletionMassiveModal from    '@/components/DeletionMassiveModal'
import draggable            from    'vuedraggable'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
export default {
    name: 'StaffingVariable',

    components: {
        Breadcrumb,
        WaitingModal,
        DeletionModal,
        FormModal,
        UpdateModal,
        DeletionMassiveModal,
        draggable
    },

    data() {
        return {
            notyf,
            axios,
            parent_id:              this.$route.params.id,
            parent:                 {},
            uncrypted_parent_id:    '',
            title_page:             'Staffing Variables',
            rest_api:               `staffing_variables`,
            table_headers:          Resources.table_headers,
            breadcrumb:             Resources.breadcrumb,
            add_btn:                'Add Staffing Variable',
            single_select:          false,
            table_selection:        [],
            search:                 '',
            global_index:           '',
            single_object:          {},
            staffing_variables:     [],
            array_options:          {},
            select_ids:             [],
            select_all:             false
        }
    },

    methods: {

        unshift_object(new_object)
        {
            this.staffing_variables.splice((new_object.order - 1), 0, new_object)
            this.updateOrd()
        },

        splice_object(splicing_object)
        {
            this.staffing_variables.splice(splicing_object.index, 1, splicing_object.single_object)
            this.updateOrd()
        },

        async updateOrd()
        {
            const form_data = {
                table: 'staffing_variables',
                data: this.staffing_variables
            }

            const data = await this.postingByPost('general_functions/post_dragging', form_data)
            this.staffing_variables = data.data;
        },

        form_modal()
        {
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.staffing_variables[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.staffing_variables[index]
            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            this.parent = data.scenario
            this.uncrypted_parent_id = data.parent_id
            this.staffing_variables = data.staffing_variables
            this.array_options = {
                staffing_scenario_id: data.staffing_scenarios,
            }
            this.breadcrumb.push(
                {
                    name:   'Staffing variable',
                    href:   '#',
                    arrow:  "<span class='slash'>/</span>",
                },
                {
                    name:   this.parent.scenario,
                    href:   '#',
                    arrow:  "",
                },
            )
        },

        trashing(index)
        {
            this.staffing_variables.splice(index, 1)
        },

        massive_modal_delete()
        {
            this.select_ids = this.staffing_variables.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                id: this.select_ids,
                massive:    true,
            }

            let sendingMassive = await this.massive_deletion(json_request)

            if(sendingMassive)
            {
                this.select_ids.forEach( item =>
                {
                const index = this.staffing_variables.findIndex(value => value.id == item)
                if(index > -1)
                {
                    this.staffing_variables.splice(index, 1)
                }
                })
                this.select_ids = []
            }
        },
    },

    async mounted()
    {
        if(this.hasPermissions(['Budgeting-Staffing-Variable Read', 'Budgeting-Staffing-Variable Write']))
        {
            await this.api_request(`${this.rest_api}/${this.parent_id}`)
        }
        else
        {
            this.$router.push('/')
        }
    },

    computed:
    {
        selected()
        {
            const bool = this.staffing_variables.filter(item => item.checked)
            return Boolean(bool.length)
        }
    },

    watch: 
    {
        async 'select_all' (val)
        {
            this.staffing_variables.map(item => item.checked = val)
        }
    }

}
</script>